import React from 'react';
export const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy-900 py-12 border-t border-navy-800" data-id="element-66">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-67">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-68">
          <div className="flex items-center gap-3" data-id="element-69">
            <img src="https://cdn.magicpatterns.com/uploads/ryk41TLetQu6VxX6oqEWhT/FullLogo.png" alt="Universal Hockey Development" className="h-12 object-contain" data-id="element-70" />
          </div>

          <nav className="flex flex-wrap justify-center gap-6 md:gap-8" data-id="element-71">
            <a href="#mission" className="text-sm font-medium text-slate-400 hover:text-white transition-colors" data-id="element-72">
              About
            </a>
            <a href="#services" className="text-sm font-medium text-slate-400 hover:text-white transition-colors" data-id="element-73">
              Services
            </a>
            <a href="#team" className="text-sm font-medium text-slate-400 hover:text-white transition-colors" data-id="element-74">
              Team
            </a>
            <a href="#network" className="text-sm font-medium text-slate-400 hover:text-white transition-colors" data-id="element-75">
              Network
            </a>
          </nav>
        </div>

        <div className="mt-8 pt-8 border-t border-navy-800 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-76">
          <p className="text-sm text-slate-500" data-id="element-77">
            &copy; {currentYear} Universal Hockey Development. All rights
            reserved.
          </p>
          <div className="flex gap-4" data-id="element-78">
            <a href="#" className="text-slate-500 hover:text-ice-500 transition-colors text-sm font-medium" data-id="element-79">
              Privacy Policy
            </a>
            <a href="#" className="text-slate-500 hover:text-ice-500 transition-colors text-sm font-medium" data-id="element-80">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
};